/** Attraction type options */
export const ATTRACTION_TYPES = ['cultural', 'natural', 'entertainment', 'religious', 'historical'] as const;
export type AttractionType = (typeof ATTRACTION_TYPES)[number];

/** Core attraction entity */
export interface Attraction {
  id: string;
  attractionId: string;
  name: string;
  description: string;
  city: string;
  state: string | null;
  country: string;
  countryCode: string;
  lePlaceId: string | null;
  latitude: number;
  longitude: number;
  type: AttractionType;
  popularityRank: number;
  imageUrl: string | null;
  active: boolean;
  offerCount: number;
}

/** City with attraction coverage data */
export interface CityWithCoverage {
  city: string;
  country: string;
  countryCode: string;
  lePlaceId: string | null;
  attractionCount: number;
  coveredCount: number;
  coverageRate: number;
}

/** Offer matched to an attraction */
export interface MatchedOffer {
  id: string;
  title: string;
  shortDescription: string;
  slug: string;
  provider: string;
  matchType: 'PROXIMITY' | 'DIRECT_TITLE' | 'KEYWORD' | 'AI_SEMANTIC';
  relevanceScore: number;
}

/** Image available for an attraction */
export interface AttractionImage {
  imageId: string;
  isHero: boolean;
  url: string;
  offerTitle: string;
  offerId: string;
}

/** Query params for listing attractions */
export interface ListAttractionsParams {
  city?: string;
  country?: string;
  countryCode?: string;
  type?: string;
  sort?: string;
  limit?: number;
  offset?: number;
  includeInactive?: boolean;
}

/** API response for a single attraction */
export interface GetAttractionResponse {
  result: Attraction;
}

/** API response for listing attractions */
export interface ListAttractionsResponse {
  result: Attraction[];
  total: number;
}

/** API response for listing cities */
export interface ListAttractionCitiesResponse {
  result: CityWithCoverage[];
}

/** API response for listing offers */
export interface ListAttractionOffersResponse {
  result: MatchedOffer[];
  total: number;
}

/** API response for listing images */
export interface ListAttractionImagesResponse {
  result: AttractionImage[];
}

/** Query params for listing attraction offers */
export interface ListAttractionOffersParams {
  limit?: number;
  offset?: number;
}

/** Formats attraction type enum for display (e.g. CULTURAL_SITE -> Cultural Site) */
export function formatAttractionType(type: string): string {
  return type
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
